<template>
    <div
        class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-4 px-lg-3 px-4 px-lg-0 py-5 py-lg-0 centrar-todo">
        <div
            class="col-12 col-lg-6 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">
            <div class="col-12 d-flex justify-content-center text-start align-items-center flex-wrap px-lg-4 w-75 mt-5">
                <span class="font- fuente-posm label-1 d-flex flex-wrap fuentes-clamp3">Invitaciones Personalizadas
                    <span></span>
                    <span class="font- label-2  fuente-nova mt-3 ps-3 w-100 fuentes-clamp4">Vende más con conexiones directas con tus clientes, basadas en sus preferencias y hábitos de consumo.

<br><br>
Crea invitaciones VIP para tus mejores clientes y envíalas directo por WhatsApp. Genera listas optimizadas para tus campañas de redes sociales.
</span>
                </span>
            </div>
        </div>
        <div style="max-width: 600px; margin: auto;">
            <video controls poster="../../../assets/images/a41.webp"
                style="width: 100%; height: auto; border-radius: 8px;">
                <source src="../../../assets/images/F.mp4" type="video/mp4">
                Tu navegador no soporta el elemento de video.
            </video>
        </div>

    </div>
</template>
<script>
export default {
    name: 'page2',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a7: require('@/assets/images/a7.webp'),
            a9: require('@/assets/images/a9.svg'),
            a14: require('@/assets/images/a41.webp'),

        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        }
    },
}
</script>
<style lang="css" scoped>
.cubeSpace {
    overflow: hidden;
    height: auto;
    width: 100vw;
    height: 100vh;
}



.spaceMedia {
    background-color: transparent;
    min-height: 400px;
}

.label-1 {
    color: var(--color-5);
    font-size: 70px;
    line-height: 1.1;
    max-width: 850px;
    word-wrap: break-word;
}

.label-2 {
    color: var(--color-5);
    font-size: 29px;
    max-width: 700px;
    line-height: 1.1;
}

.label-3 {
    color: var(--color-5);
    font-size: 30px;
    line-height: 1.1;
}

.btnPlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    width: 100px;
    height: 100px;
}

.btnPlay svg {
    width: 100%;
    height: 100%;
}

@media (max-width: 992px) and (min-width: 768px) {
    .label-1 {
        font-size: 60px;
    }

    .label-2 {
        font-size: 27px;
    }

    .label-3 {
        font-size: 28px;
    }
}

@media (max-width: 767px) and (min-width: 0) {
    .label-1 {
        font-size: 28px;
    }

    .label-2 {
        font-size: 19px;
    }

    .label-3 {
        font-size: 20px;
    }
}
</style>